var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6852 22.1296V23.5555C17.6852 25.9181 15.77 27.8333 13.4074 27.8333C11.0449 27.8333 9.12963 25.9181 9.12963 23.5555V22.1296M17.6852 22.1296H9.12963M17.6852 22.1296H22.805C23.3504 22.1296 23.6245 22.1296 23.8453 22.0551C24.2672 21.9128 24.5973 21.5816 24.7396 21.1597C24.8144 20.9379 24.8144 20.663 24.8144 20.1133C24.8144 19.8727 24.8141 19.7524 24.7953 19.6377C24.7598 19.421 24.6756 19.2155 24.5475 19.0371C24.4798 18.9428 24.3938 18.8568 24.2242 18.6872L23.6688 18.1317C23.4896 17.9525 23.3889 17.7094 23.3889 17.456V12.1481C23.3889 6.63551 18.92 2.16664 13.4074 2.16666C7.8948 2.16667 3.42593 6.63553 3.42593 12.1481V17.456C3.42593 17.7095 3.32503 17.9525 3.14583 18.1317L2.59042 18.6871C2.4203 18.8573 2.33515 18.9427 2.26736 19.0371C2.13925 19.2156 2.05439 19.421 2.01882 19.6377C2 19.7524 2 19.8727 2 20.1133C2 20.6631 2 20.9379 2.07479 21.1596C2.2171 21.5815 2.54869 21.9128 2.97058 22.0551C3.19145 22.1296 3.46445 22.1296 4.00992 22.1296H9.12963",
    stroke: "#D1D6DD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification_bell.6690d3ad355d098882871792f46916f4.svg";
export { ForwardRef as ReactComponent };